import React, { useEffect, useState } from "react"
import classes from './AveragingScoreChart.module.css'
import { useSelector } from "react-redux"



const AveragingScoreChart = ({ avergeScore, avergeClass, progress }) => {
    const [myGrade, setMyGrade] = useState()
    const [classGrade, setClassGrade] = useState()
    const texts = useSelector(state => state.translate.texts);
    const direction = useSelector(state => state.translate.direction);

    useEffect(() => {
        setMyGrade(getScorePosition(avergeScore))
    }, [avergeScore])

    useEffect(() => {
        setClassGrade(getScorePosition(avergeClass))
    }, [avergeClass])

    function getScorePosition(avergeScore) {
        if (avergeScore || avergeScore === 0) {
            let temp = (100 - avergeScore) === 0 ? 1 : 100 - avergeScore;
            if (avergeScore >= 60)
                return (temp / 40) * 165
            return (temp / 60) * 50 + 130;
        }
        else
            return 0
    }
    return (
        <div className={`${classes.Chart} ${classes[direction]}`}>
            {(myGrade || myGrade === 0) && <div className={classes.avergeScore} style={{ top: `calc( ${myGrade}px - 27px)` }}>
                <div className={classes.RightArrow} ></div>
                <div className={classes.AvergeScoreWithMyProgress}>

                    <div className={classes.avergeScoreTxt}>{(Math.round(avergeScore * 10) / 10) == 0 ? (Math.round(avergeScore * 10) / 10) : (Math.round(avergeScore * 10) / 10).toFixed(0)}</div>
                    {progress >= 0 && <div className={classes.MyProgressLast}>
                        <div className={classes.LastStateProgressText}> {`${progress > 0 ? '+' : ''}`}{progress == 0 ? progress : progress.toFixed(0)} </div>
                        {<div className={`${progress > 0 ? classes.TriangleUp : classes.TriangleDown}`} > </div>}
                    </div>}
                </div>
            </div>}

            <div className={classes.ScoreBar}></div>
            {avergeClass && (classGrade || classGrade === 0) && <div className={classes.AvergeClass} style={{ top: `calc( ${classGrade}px - 6.5px)` }}>
                <div className={classes.LeftArrow}><div>{(Math.round(avergeClass * 10) / 10) == 0 ? (Math.round(avergeClass * 10) / 10) : (Math.round(avergeClass * 10) / 10).toFixed(1)} </div></div>
                <div className={classes.AvergeClassTxt}>{texts.avergeClass} </div>
            </div>}
        </div >
    )
}
export default AveragingScoreChart